<template>
  <div :class="['index-classify-pop-root',isApp?'':'top']">
    <!-- @touchmove.prevent -->
    <div class="flex-row">
      <div class="flex index-pop-item-layout">
        <div class="index-pop-height flex-row ct" v-for="(item,index) in classifyList1" :key="index"
          v-on:click="item1Click(item,index)"
          v-bind:class="[selectIndex1 === index ? 'index-pop-layout-select' : 'index-pop-layout-unselect']">
          <div class="index-pop-span-indicator"
            v-bind:class="[selectIndex1 === index ? 'index-pop-span-show' : 'index-pop-span-hidden']"></div>
          <div class="flex line1"
            v-bind:class="[selectIndex1 === index ? 'index-pop-text-select' : 'index-pop-text-unselect']">
            {{item.category_name}}</div>
        </div>
      </div>
      <div class="flex index-pop-item-empty" v-bind:class="[this.selectIndex2 < 0 ? 'show' : 'hidden']"
        v-on:click="closePop"></div>
      <div class="flex index-pop-item-layout index-pop-item-left-line"
        v-bind:class="[this.selectIndex2 < 0 ? 'hidden' : 'show']">
        <div class="index-pop-height flex-row ct" v-for="(item,index) in classifyList2" :key="index"
          v-on:click="item2Click(item,index)"
          v-bind:class="[selectIndex2 === index ? 'index-pop-layout-select' : 'index-pop-layout-unselect']">
          <div class="index-pop-span-indicator"
            v-bind:class="[selectIndex2 === index ? 'index-pop-span-show' : 'index-pop-span-hidden']"></div>
          <div class="flex index-pop-text-unselect line1">{{item.category_name}}</div>
        </div>
      </div>
      <div class="flex index-pop-item-empty" v-bind:class="[this.selectIndex3 < 0 ? 'show' : 'hidden']"
        v-on:click="closePop"></div>
      <div class="flex index-pop-item-layout index-pop-item-left-line"
        v-bind:class="[this.selectIndex3 < 0 ? 'hidden' : 'show']">
        <div class="index-pop-height flex-row ct" v-for="(item,index) in classifyList3" :key="index"
          v-on:click="item3Click(item,index)"
          v-bind:class="[selectIndex3 === index ? 'index-pop-layout-select' : 'index-pop-layout-unselect']">
          <div class="index-pop-span-indicator"
            v-bind:class="[selectIndex3 === index ? 'index-pop-span-show' : 'index-pop-span-hidden']"></div>
          <div class="flex index-pop-text-unselect line1">{{item.category_name}}</div>
        </div>
      </div>
    </div>
    <div class="index-classify-pop-other" v-on:click="closePop"></div>
  </div>
</template>

<script>
export default {
  name: 'index-classify-pop',
  props: {
    isApp: {
      type: Boolean,
      default: true
    },
    index1: {
      type: Number,
      default: 0
    },
    index2: {
      type: Number,
      default: 0
    },
    index3: {
      type: Number,
      default: 0
    },
    classifyList1: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedClassifyList2: { // 自动选中的二级分类数据
      type: Array,
      default: () => {
        return []
      }
    },
    selectedClassifyList3: { // 自动选中的三级分类数据
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    index1: function (newVal) {
      this.selectIndex1 = newVal
    },
    index2: function (newVal) {
      this.selectIndex2 = newVal
    },
    index3: function (newVal) {
      this.selectIndex3 = newVal
    },
    selectedClassifyList2: function (newList) {
      this.classifyList2 = newList
    },
    selectedClassifyList3: function (newList) {
      this.classifyList3 = newList
    }
  },
  data () {
    return {
      selectIndex1: 0,
      selectIndex2: -1,
      selectIndex3: -1,
      classifyList2: [],
      classifyList3: []
    }
  },
  methods: {
    item1Click: function (item, index) {
      this.selectIndex1 = index
      const list2 = this.classifyList1[index].sonList
      // 先清空之前的二三级数据
      this.classifyList2 = []
      this.classifyList3 = []
      if (list2 === undefined || list2 === null || list2.length <= 0) { // 没有二级数据
        this.selectIndex2 = -1
        this.selectIndex3 = -1
        const item1 = this.classifyList1[this.selectIndex1]
        this.$emit('onIndexPopSelect', 1, item1, null, null, this.selectIndex1, -1, -1)
      } else { // 有二级数据
        this.selectIndex2 = 0
        this.classifyList2 = this.classifyList2.concat(list2)
        // 是否包含全部
        let hasAll = false
        this.classifyList2.every((item) => {
          if (item.id === -1) {
            hasAll = true
            return false
          } else {
            return true
          }
        })
        if (!hasAll) {
          this.classifyList2.splice(0, 0, {
            category_name: '全部',
            id: -1,
            sonList: []
          })
        }
        this.selectIndex3 = -1
      }
    },
    item2Click: function (item, index) {
      this.selectIndex2 = index
      const list3 = this.classifyList2[index].sonList
      // 清空之前的三级数据
      this.classifyList3 = []
      if (list3 === undefined || list3 === null || list3.length <= 0) { // 没有三级数据
        this.selectIndex3 = -1
        const item1 = this.classifyList1[this.selectIndex1]
        const item2 = this.classifyList2[this.selectIndex2]
        this.$emit('onIndexPopSelect', 2, item1, item2, null, this.selectIndex1, this.selectIndex2, -1)
      } else {
        this.selectIndex3 = 0
        this.classifyList3 = this.classifyList3.concat(list3)
        let hasAll = false
        this.classifyList3.every((item) => {
          if (item.id === -1) {
            hasAll = true
            return false
          } else {
            return true
          }
        })
        if (!hasAll) {
          this.classifyList3.splice(0, 0, {
            category_name: '全部',
            id: -1
          })
        }
      }
    },
    item3Click: function (item, index) {
      this.selectIndex3 = index
      const item1 = this.classifyList1[this.selectIndex1]
      const item2 = this.classifyList2[this.selectIndex2]
      const item3 = this.classifyList3[this.selectIndex3]
      this.$emit('onIndexPopSelect', 3, item1, item2, item3, this.selectIndex1, this.selectIndex2, this.selectIndex3)
    },
    closePop: function () {
      this.$emit('onIndexPopSelect', 0, null, null, null, null, null, null)
    }
  }
}
</script>

<style scoped>
.flex-row {
  display: flex;
  flex-direction: row;
}
.ct {
  align-items: center;
  justify-content: center;
}
.flex {
  flex: 1;
}
.show {
  /*visibility: visible;*/
  display: block;
}
.hidden {
  /*visibility: hidden;*/
  display: none;
}
.line1 {
  max-lines: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.index-classify-pop-root {
  position: fixed;
  top: 105px;
  width: 100%;
  /*height: 100%;*/
  bottom: 50px;
  background: rgba(0, 0, 0, 0.6);
  z-index: 600;
}
.index-classify-pop-root.top {
  position: fixed;
  top: 50px;
  width: 100%;
  /*height: 100%;*/
  bottom: 0px;
  background: rgba(0, 0, 0, 0.6);
  z-index: 600;
}
.index-pop-item-layout {
  height: 400px;
  overflow-y: scroll;
  background: white;
}
.index-pop-item-empty {
  height: 400px;
}
.index-pop-item-left-line {
  border-left-style: solid;
  border-left-width: 1px;
  border-left-color: #f2f2f2;
}
.index-pop-height {
  height: 42px;
}
.index-pop-span-indicator {
  width: 5px;
  height: 18px;
  background: #c41335;
}
.index-pop-span-show {
  visibility: visible;
}
.index-pop-span-hidden {
  visibility: hidden;
}
.index-pop-text-unselect {
  color: black;
  line-height: 42px;
  font-size: 12px;
  margin-left: 10px;
}
.index-pop-text-select {
  color: #c41335;
  line-height: 42px;
  font-size: 12px;
  margin-left: 10px;
}
.index-pop-layout-unselect {
  background: white;
}
.index-pop-layout-select {
  background: #eeeeee;
}
.index-classify-pop-other {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/goods/index-classify-pop.vue